// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1KryG","amount":"Amount_amount__1cNFB","tip":"Amount_tip__3h7Gh","tipHeader":"Amount_tipHeader__1JZm3","tipsWrap":"Amount_tipsWrap__2FoWz"};